import React, { useState, useRef, useEffect } from "react";

// assets and scss imports ⇒
import "./mobileNumberVerification.scss";
import backArrow from "../../../../assets/back_arrow_gray.svg";

// project file imports(UI components) ⇒
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import PhoneNumberInputWithAction from "../../../common/PhoneNumberInputWithAction";
import OTPInput from "../../../common/OTPInput";
import Loader from "../../../UI Component/Loader/Loader";
import AbhaAddressListView from "../AbhaAddressListView";
import LearnMorePopup from "../../../common/Popups/LearnMorePopup";
import TermsAndConditionPopup from "../../../common/Popups/TermsAndConditionPopup";
import AbhaNotFoundView from "../AbhaNotFoundView";
import {
  GET_ABHA_PROFILE_DETAILS,
  GET_OTP_FOR_MOBILE,
  SEND_OTP_FOR_VERIFICATION,
} from "../../APIHandler/apiConstants";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";
import AbhaConfirmationDetails from "../../../common/AbhaConfirmationDetails";
import SecondaryButton from "../../../common/Buttons/SecondaryButton";
import { PROD } from "../../../common/config";
import CreateAbhaFromMobileVerification from "../CreateAbhaFromMobileVerification";
import { handleAbhaGenderFormat } from "../helper";

const MobileNumberVerification = (props) => {
  // const declarations ⇒
  const {
    mobileNumberStep,
    existingPatientDetails,
    handleSubmitExistingPatientDetails,
    handleSubmitAbhaPatientDetails,
    handleMobileNumberSteps,
    handleRightArrowBtn,
    handleBack,
  } = props;
  const [mobileNumber, setMobileNumber] = useState("");

  const [pageLoader, setPageLoader] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [otpInputFlag, setOtpInputFlag] = useState(false);
  const [disableMobileNumberContinueBtn, setDisableMobileNumberContinueBtn] =
    useState(true);
  const [mobileNumberActionBtnFlag, setMobileNumberActionBtnFlag] =
    useState(false);
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [otpErrorFlag, setOptErrorFlag] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [abhaAddressList, setAbhaAddressList] = useState([]);
  const [selectedAbhaAddress, setSelectedAbhaAddress] = useState({});
  const [abhPatientDetails, setAbhaPatientDetails] = useState({});
  const [abhaToken, setAbhaToken] = useState("");
  const [hideResendBtn, setHideResendBtn] = useState(false);
  const [hideActionIcon, setHideActionIcon] = useState(true);
  const [resetOtp, setResetOtp] = useState(false);

  // API call

  const getOTPforMobileVerification = (isResend) => {
    let reqPayload = {
      mobile_number: mobileNumber,
    };
    const getOtpResponse = c2cPostApiHandler(GET_OTP_FOR_MOBILE, reqPayload); //Fetch API Data
    getOtpResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setTransactionId(res?.data?.txnId);
          setOtpInputFlag(true);
          setMobileNumberError("");
          setHideResendBtn(false);
        } else if (res?.data?.statusCode === 502) {
          handleMobileNumberSteps(3);
        } else if (res?.data?.statusCode === 503) {
          handleApiError(res, isResend);
          setHideResendBtn(true);
        } else {
          handleApiError(res, isResend);
        }
      } else {
        handleApiError(res, isResend);
      }
    });
  };

  const sendOTPforMobileVerification = () => {
    let reqPayload = {
      txnId: transactionId,
      otp: otpInput,
    };
    const verifyOtpResponse = c2cPostApiHandler(
      SEND_OTP_FOR_VERIFICATION,
      reqPayload
    );
    verifyOtpResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setOtpErrorMsg("");
          setOptErrorFlag(false);
          setAbhaToken(res?.data?.token);
          if (res?.data?.accounts?.length > 0) {
            res.data.accounts.forEach((data) => {
              data.selected = false;
              data["preferred_abha_address"] = data?.preferredAbhaAddress;
            });
            setAbhaAddressList([...res?.data?.accounts]);
            handleMobileNumberSteps(2);
          }
        } else if (res?.data?.statusCode === 502) {
          setOtpErrorMsg("Incorrect OTP");
          setOptErrorFlag(true);
        } else {
          setOtpErrorMsg(res?.data?.message);
          setOptErrorFlag(true);
        }
      } else {
        setOtpErrorMsg(res?.data?.message);
        setOptErrorFlag(true);
      }
    });
  };

  const getAbhaProfileDetails = () => {
    let reqPayload = {
      txnId: transactionId,
      ABHANumber: selectedAbhaAddress?.ABHANumber,
      token: abhaToken,
      patient_account_id: existingPatientDetails?.patient_account_id,
    };
    const abhaProfileResponse = c2cPostApiHandler(
      GET_ABHA_PROFILE_DETAILS,
      reqPayload
    );
    abhaProfileResponse.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          res.data["preferred_abha_address"] =
            res?.data?.preferredAbhaAddress?.split("@")[0];
          res.data["name"] = `${res?.data?.firstName} ${
            res?.data?.middleName ? res?.data?.middleName : ""
          } ${res?.data?.lastName ? res?.data?.lastName : ""}`;
          res.data["state"] = res?.data?.stateName;
          res.data["gender"] = handleAbhaGenderFormat(res?.data?.gender);
          setAbhaPatientDetails(res?.data);
          handleMobileNumberSteps(5);
        }
      }
    });
  };

  const handleResendOTP = () => {
    setResetOtp(true);
    setOtpErrorMsg("");
    setOptErrorFlag(false);
    getOTPforMobileVerification(true);
  };

  const handleOnChangeOtp = (otpInput) => {
    setOtpInput(otpInput);
    setOtpErrorMsg("");
    setOptErrorFlag(false);
    if (otpInput?.length === 6) {
      setDisableMobileNumberContinueBtn(false);
    } else {
      setDisableMobileNumberContinueBtn(true);
    }
  };

  const onChangeMobileNumber = (number) => {
    setMobileNumber(number);
    setMobileNumberError("");
    setOtpErrorMsg("");
    setOptErrorFlag(false);
    setOtpInputFlag(false);
    if (number?.length === 10) {
      setMobileNumberActionBtnFlag(true);
      setHideActionIcon(false);
    } else {
      setMobileNumberActionBtnFlag(false);
    }
  };

  const handleKeyDownInMobileNoInput = (e) => {
    if (e.key !== "Backspace" && e.key !== "Delete") {
      if (e.key === "Enter" && mobileNumber?.length === 10) {
        handleMobileNumberInputAction();
      }
    }
  };
  const handleMobileNumberInputAction = () => {
    setHideActionIcon(true);
    handleRightArrowBtn && handleRightArrowBtn();
    getOTPforMobileVerification();
  };

  const handleMobileNumberContinueBtn = () => {
    sendOTPforMobileVerification();
  };

  const handleSelectAbhaAddress = (abha_item) => {
    let tempAddressList = [...abhaAddressList];
    tempAddressList.forEach(
      (data) =>
        (data.selected =
          data?.preferredAbhaAddress === abha_item?.preferredAbhaAddress)
    );
    setAbhaAddressList(tempAddressList);
    setSelectedAbhaAddress(abha_item);
  };

  const handleAddListContinue = () => {
    getAbhaProfileDetails();
  };

  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  const handleConfirmationModal = (abhaDetails) => {
    setAbhaPatientDetails(abhaDetails);
    handleMobileNumberSteps(5);
  };

  const handleApiError = (res, isResend) => {
    if (isResend) {
      setOtpErrorMsg(res?.data?.message);
      setOptErrorFlag(true);
    } else {
      setMobileNumberError(res?.data?.message);
    }
  };

  // Create UI ⇒
  const mobileNumberOtpInputSection = () => {
    return (
      <div className="mnvc-otp-ui">
        <OTPInput
          hasError={otpErrorFlag}
          errorMessage={otpErrorMsg}
          timerUnit={1}
          hideTimerResendBtn={hideResendBtn}
          onChangeOTP={handleOnChangeOtp}
          handleResendOTP={handleResendOTP}
          autoFocus={true}
          resetOtp={resetOtp}
          setResetOtp={setResetOtp}
        />
      </div>
    );
  };

  const mobileNumberInputUI = () => {
    return (
      <div className="mobile-no-input-ui">
        <div className="mnvc-input-label">Enter Mobile Number</div>
        <p className="description">
          We just sent you OTP on your mobile number which is linked to your
          ABHA ID
        </p>
        <div
          className={`mobile-no-input ${mobileNumberError && "mnvc-mni-error"}`}
        >
          <PhoneNumberInputWithAction
            placeholder={"Enter Phone Number"}
            inputValue={mobileNumber}
            disabled={false}
            showRegisterButtonLoader={false}
            handleInputChange={onChangeMobileNumber}
            handleInputAction={handleMobileNumberInputAction}
            handleKeyDown={handleKeyDownInMobileNoInput}
            autoFocus={true}
            hideActionIcon={hideActionIcon}
          />
          {mobileNumberError && (
            <div className="mnvc-error-msg">{mobileNumberError} </div>
          )}
          {otpInputFlag && mobileNumberOtpInputSection()}
        </div>
        {mobileNumberContinueBtn()}
      </div>
    );
  };

  const mobileNumberContinueBtn = () => {
    return (
      <div className="mnvc-continue-btn-wrapper">
        <PrimaryButton
          title="Continue"
          disabled={disableMobileNumberContinueBtn}
          handleButtonClick={handleMobileNumberContinueBtn}
        />
      </div>
    );
  };

  const aadharConfirmationSection = () => {
    return (
      <div className="pavc-aadhar-conf-section">
        <div className="pavc-back-btn-cont">
          <img
            src={backArrow}
            alt=""
            className="pavc-back-btn"
            onClick={handleBack}
          />
        </div>
        <div className="pavc-aadhar-conf-section-heading">
          <h5>Confirmation!</h5>
          <p>
            Patient Details will be updated as per <br />
            the ABHA Address "
            <span className="pavc-aadhar-conf-section-heading">
              {getAbhaAddress(abhPatientDetails?.preferred_abha_address)}
            </span>
            ".Do you want to continue ?
          </p>
        </div>
        <AbhaConfirmationDetails
          appointmentDetails={existingPatientDetails}
          abhPatientDetails={abhPatientDetails}
        />
        <div className="pd-abha-qr-data-confirmation-footer-container">
          <div className="pd-abha-qr-data-confirmation-footer-left-btn">
            <SecondaryButton
              title="No"
              handleButtonClick={() =>
                handleSubmitExistingPatientDetails(
                  abhPatientDetails?.preferred_abha_address,
                  abhPatientDetails?.ABHANumber
                )
              }
            />
          </div>
          <div className="pd-abha-qr-data-confirmation-footer-right-btn">
            <PrimaryButton
              title="Yes"
              handleButtonClick={() =>
                handleSubmitAbhaPatientDetails(abhPatientDetails)
              }
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-number-verification-container">
      {pageLoader && <Loader />}
      {mobileNumberStep === 1 && (
        <div className="mnvc-pd">{mobileNumberInputUI()}</div>
      )}
      {mobileNumberStep === 2 && (
        <div className="mnvc-pd">
          <AbhaAddressListView
            mobileNumber={mobileNumber}
            abhaAddressList={abhaAddressList}
            handleSelectAbhaAddress={handleSelectAbhaAddress}
            handleAddListContinue={handleAddListContinue}
          />
        </div>
      )}
      {mobileNumberStep === 3 && (
        <div className="mnvc-pd">
          <AbhaNotFoundView handleMobileNumberSteps={handleMobileNumberSteps} />
        </div>
      )}
      {mobileNumberStep === 4 && (
        <CreateAbhaFromMobileVerification
          mobileNumber={mobileNumber}
          existingPatientDetails={existingPatientDetails}
          handleSubmitExistingPatientDetails={
            handleSubmitExistingPatientDetails
          }
          handleSubmitAbhaPatientDetails={handleSubmitAbhaPatientDetails}
          handleConfirmationModal={handleConfirmationModal}
        />
      )}
      {mobileNumberStep === 5 && aadharConfirmationSection()}
    </div>
  );
};

export default MobileNumberVerification;
